







import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'NotFoundComponent'
})

export default class NotFoundComponent extends Vue {}
